import { memo } from "react";

type Props = {
  id: any;
  fileName: string;
};

const PreviewImage = memo((props: Props) => {
  const apiUrl = process.env.REACT_APP_API_URL;

  return (
    <img
      className="object-fit-cover aspect-ratio-16-9"
      src={`${apiUrl}/storages/${
        props.fileName
      }?thumbnail=true&t=${new Date().getTime()}&tenant=${props.id}`}
      alt="img-operative-note"
      style={{ borderRadius: "6px" }}
      loading="lazy"
    />
  );
});
PreviewImage.displayName = "PreviewImage";

export default PreviewImage;
